import { Component, AfterViewInit, Input } from '@angular/core';

import { PdfExportService } from '../../../../services/export-pdf/pdf-export.service';
import { UserService } from '../../../../services/user.service';
import { InfluencerPost, BestPerformingExposure } from '../../../../../models/influencer';

@Component({
  selector: 'best-performing-posts',
  templateUrl: './best-performing-posts.component.html',
  styleUrls: ['./best-performing-posts.component.scss']
})
export class BestPerformingPostsComponent implements AfterViewInit {
  static COMPONENT_NAME = 'BestPerformingPostsComponent';
  @Input() bestPerformingPosts: BestPerformingExposure[] = [];
  @Input() forPayingUser = false;
  @Input() printMode: boolean;
  @Input() isFetchingData: boolean;

  constructor(private pdfService: PdfExportService,
    private userService: UserService) {
  }

  ngAfterViewInit() {
    if (this.bestPerformingPosts.length === 0) {
      this.pdfService.incrementNumberReportReady(BestPerformingPostsComponent.COMPONENT_NAME);
    }
    this.pdfService.imagedLoadedTrigger.subscribe(data => {
      if (data.component === BestPerformingPostsComponent.COMPONENT_NAME
        && data.currentCounter === this.bestPerformingPosts.length) {
        this.pdfService.incrementNumberReportReady(BestPerformingPostsComponent.COMPONENT_NAME);
      }
    });
  }

  get hasNoData() {
    return !Array.isArray(this.bestPerformingPosts)
      || this.bestPerformingPosts.length === 0
      || (this.forPayingUser && this.userService.isFreeUser() && !this.userService.isAdmin);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-insight/best-performing-posts/best-performing-posts.component.ts